export default "__VITE_ASSET__kF62aBzz__"